export default "__VITE_ASSET__ZIER$Ap6__"